import React from 'react';
import OpportunityListPage from './OpportunityListPage';

export default function BusinessPage() {
  return <OpportunityListPage opportunityType="Business_Opportunity" />;
}